function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useEffect, useRef, useState } from 'react';
import { getChat } from "../../../api/requests/chat";
import { useAuth } from "../../Auth";
import { useMessenger } from "../../Messenger";
import { useSocket } from "../../Socket";
import { mapMessage, messageConstructor } from "../helpers";
import { saveFileInAwsAndSendMessage } from "../../../helpers/saveFileInAws";
import { useChat } from "./useChat";
import { useErrors } from "../../Errors/hooks/useErrors";
export const useMessages = _ref => {
  let pages = _ref.pages;
  const socket = useSocket();

  const _useAuth = useAuth(),
        user = _useAuth.user,
        connected = _useAuth.connected;

  const _useErrors = useErrors(),
        handleShowError = _useErrors.handleShowError;

  const _useMessenger = useMessenger(),
        selectedChat = _useMessenger.selectedChat;

  const selectedChatRef = useRef(selectedChat);

  const _useState = useState(),
        _useState2 = _slicedToArray(_useState, 2),
        replyingTo = _useState2[0],
        setReplyingTo = _useState2[1];

  const _useState3 = useState(),
        _useState4 = _slicedToArray(_useState3, 2),
        messages = _useState4[0],
        setMessages = _useState4[1];

  const _useState5 = useState([]),
        _useState6 = _slicedToArray(_useState5, 2),
        pendingMessages = _useState6[0],
        setPendingMessages = _useState6[1];

  const thereIsMore = useRef(false);
  useEffect(() => selectedChatRef.current = selectedChat, [selectedChat]);

  const fetchMessages = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (selectedChatId) {
      if (selectedChatId) {
        try {
          const _yield$getChat = yield getChat({
            userId: user?.id,
            withUserId: selectedChatId,
            page: 1,
            rowsPerPage: 60
          }),
                totalPages = _yield$getChat.totalPages,
                messages = _yield$getChat.messages;

          if (selectedChatRef.current?.id === selectedChatId) {
            setMessages(messages);
            thereIsMore.current = totalPages > 1;
            pages.current = [1, 2, 3];
          }
        } catch (error) {
          handleShowError(error.message);
          setMessages(null);
        }
      } else {
        setMessages(null);
      }
    });

    return function fetchMessages(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(() => {
    setMessages(null);
    setPendingMessages([]);
    fetchMessages(selectedChat?.id);
  }, [selectedChat]);
  useEffect(() => {
    connected && socket.on('private_message', _message => {
      const message = mapMessage(_message);

      if (message.type === 'album') {
        message.content = JSON.parse(message.content || '');
      }

      if (message.from === selectedChatRef.current?.id || message.to === selectedChatRef.current?.id) {
        if (pages.current[0] === 1) {
          setMessages(messages => {
            if (!messages) {
              return messages;
            } else {
              if (messages.length >= 60) {
                thereIsMore.current = true;
                return [...messages.slice(1), message];
              } else {
                return [...messages, message];
              }
            }
          });
        } else {
          setMessages(null);
          fetchMessages(selectedChatRef.current?.id);
        }

        setPendingMessages(pendingMessages => pendingMessages.filter(pendingMessage => !(pendingMessage.temporalId === message.temporalId)));
      }
    });
  }, [connected]);

  const handleSendMessage = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(function* (data) {
      const message = messageConstructor({
        from: user.id,
        to: selectedChat.id,
        replyTo: replyingTo?.id || null,
        data
      });

      if (data.type !== 'text') {
        try {
          yield saveFileInAwsAndSendMessage(data, message, socket);
        } catch (error) {
          handleShowError(error.message);
          return;
        }
      } else {
        socket.emit('private_message', message);
      }

      setPendingMessages(messages => [...messages, message]);
      setReplyingTo(null);
      document.getElementById('chatInput').focus();
    });

    return function handleSendMessage(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  return {
    messages,
    setMessages,
    pendingMessages,
    replyingTo,
    setReplyingTo,
    handleSendMessage,
    thereIsMore
  };
};